// extracted by mini-css-extract-plugin
module.exports = {"sticky-cta-bar":"public_provider_sticky_cta_sticky-cta-bar__xYrNl"};